import { render } from "./FISPQ.vue?vue&type=template&id=0cd6763d&scoped=true"
import script from "./FISPQ.vue?vue&type=script&lang=js"
export * from "./FISPQ.vue?vue&type=script&lang=js"

import "./FISPQ.vue?vue&type=style&index=0&id=0cd6763d&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd6763d"]])

export default __exports__